var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "swap-item-container",
      class: { "swap-item--invalid": _vm.invalid }
    },
    [
      _c("img", {
        staticClass: "close-modal",
        attrs: { src: _vm.imageUrl("close-modal.png") },
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.closeSwapModal.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      !_vm.noProductsFoundMessage
        ? _c(
            "div",
            {
              staticClass: "title replacement",
              class: { hasProducts: _vm.substituteProducts.length }
            },
            [_vm._v("\n        Swipe to find a replacement Item\n    ")]
          )
        : _c("div", { staticClass: "title fade-in" }, [
            _vm._v("\n        No Substitute Items Found\n    ")
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.substituteProducts.length
            ? _c("slideshow", {
                attrs: {
                  images: _vm.substituteProducts.map(function(product) {
                    return product.product_image_url
                  }),
                  zoomImages: _vm.substituteProducts.map(function(product) {
                    return product.product_image_zoom_uri
                  }),
                  product: true,
                  classes: { "swap-container": true },
                  slideshowHeight: "31vh"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "loading-overlay"
          },
          [_c("loader")],
          1
        )
      ]),
      _vm._v(" "),
      _vm.substituteProducts.length
        ? _c("div", { staticClass: "product-info" }, [
            _vm.substituteProduct.product_brand
              ? _c("div", { staticClass: "product-brand" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.substituteProduct.product_brand) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "line-clamp",
                    rawName: "v-line-clamp",
                    value: _vm.descriptionLineClamp,
                    expression: "descriptionLineClamp"
                  }
                ],
                staticClass: "product-title"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.substituteProduct.product_title) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "product-price" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("currency")(_vm.substituteProduct.product_price)
                  ) +
                  "\n        "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "buttons-container",
          class: { "with-size-select": _vm.showSizeSelect }
        },
        [
          _vm.showSizeSelect
            ? _c("div", { staticClass: "select-fix" }, [
                _c(
                  "select",
                  {
                    domProps: {
                      value: _vm.substituteProduct.product_option_value_id_size
                    },
                    on: { change: _vm.setSize }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("Choose a size")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.getSortedSizes, function(size) {
                      return _c(
                        "option",
                        {
                          key: size.product_option_value_id,
                          domProps: { value: size.product_option_value_id }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(size.product_option_value_title) +
                              "\n                "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "wtw-container small" }, [
            _c(
              "div",
              {
                staticClass: "button pink full-width",
                class: {
                  disabled: !_vm.substituteProducts.length || _vm.loading
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.swapProduct.apply(null, arguments)
                  }
                }
              },
              [_vm._v("\n                Swap it!\n            ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "button outline full-width",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.closeSwapModal.apply(null, arguments)
                  }
                }
              },
              [_vm._v("\n                Nevermind\n            ")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7695a59c", { render: render, staticRenderFns: staticRenderFns })
  }
}